<template>
  <div class="p-grid">
    <Jumbotron
      urlImage="../../assets/layout/images/bienestar_del_cirujano_banner.jpg"
      :title="$t('messages.surgeonWellness')"
      :subtitle="$t('messages.surgeonWellnessDescription')"
    />
    <ComoSerParte />
    <div class="p-col-12 contenedor-galeria">
      <GaleriaComponent :images="images" :showLabel="false" />
    </div>
  </div>
</template>

<script>
import Jumbotron from "../layout/jumbotron_main.vue";
import ComoSerParte from "../layout/como_ser_parte.vue";
import GaleriaComponent from "../layout/galeria.vue";
export default {
  metaInfo: {
    title: 'Beneficios del cirujano - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Beneficios del cirujano - QualityCare',
        content: 'QualityCare ofrece beneficios para los cirujanos, para que puedan trabajar en un ambiente agradable y seguro',
      },
    ],
  },
  name: "BienestarCirujanos",
  components: {
    ComoSerParte,
    GaleriaComponent,
    Jumbotron,
  },
  data() {
    return {
      images: [
        {
          itemImageSrc: "./assets/layout/gallery/centro-enfermeria-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/centro-enfermeria-1-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/centro-enfermeria-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/centro-enfermeria-2-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/cafeteria-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/cafeteria-2-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-1-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-4.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-4-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-3.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-3-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-2-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/vestier-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/vestier-2-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/vestier-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/vestier-1-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-cirugia-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-cirugia-1-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-cirugia-8.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-cirugia-8-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-cirugia-9.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-cirugia-9-t.jpg",
          texto: "salas de cirugías",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-6.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-6-t.jpg",
          texto: "salas de cirugías",
        },
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.contenedor-galeria {
  padding: 20px 300px;
  background-color: #ffffff;
}
@media screen and (max-width: 1200px) {
  .contenedor-galeria {
    padding: 20px 10px;
  }
}
</style>
